module.exports = __webpack_public_path__ + "img/证书2.55f99ab6.jpg";